(() => {

    /**
        Make a string's first character uppercase
     */
    angular.module('filters')
        .filter('ucfirst', () => (string) => {

            if (!string) {

                return '';

            }

            return string.charAt(0).toUpperCase() + string.slice(1);

        });

})();



// WEBPACK FOOTER //
// ./scripts/filters/ucfirst.js